import { useGetWorkspaceRolesQuery } from 'src/apiClients';

import { LazyCountChip } from './LazyCountChip';

export interface WorkspaceUserCountChipProps {
    workspaceId: string;
    tenantId: string;
}

/**
 * Renders the user count for a workspace row. Defers the query until the
 * element scrolls into view to avoid an N+1 request burst when many workspace
 * rows are rendered simultaneously.
 */
export const WorkspaceUserCountChip = ({ workspaceId, tenantId }: WorkspaceUserCountChipProps) => {
    const useCount = (enabled: boolean) => {
        const {
            data: roles,
            isLoading,
            isError,
        } = useGetWorkspaceRolesQuery({ workspaceId, tenantId }, { skip: !enabled });
        return {
            count: roles ? roles.length : undefined,
            isLoading,
            isError,
        };
    };

    return <LazyCountChip useCount={useCount} />;
};
